import { styled } from "../../../styled-components";
import { css } from "styled-components";

const disabledProps = css`
    opacity: 0.4;
    pointer-events: none;
`;

export const NotePreviewStyle = styled.div<{ isEnabled: boolean }>`
    padding: ${p => p.theme.componentInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;
    ${p => !p.isEnabled && disabledProps}

    .note-body-area {
        padding: 12px;
        border-radius: 6px;
        background-color: ${p => p.theme.picker.backgroundColor};

        :hover,
        :focus {
            background-color: ${p => p.theme.picker.hoverBgColor};
        }

        cursor: pointer;
    }

    .add-label {
        color: ${p => p.theme.fgColorLight};
        ${p => p.theme.fontStyles.Body4};

        display: flex;
        align-items: center;

        & > span {
            margin-left: 8px;
        }
    }

    .header {
        color: ${p => p.theme.fgColorMedium};
        ${p => p.theme.fontStyles.Header5};

        margin-bottom: 8px;
    }

    .body-wrapper {
        color: ${p => p.theme.fgColorDark};
        ${p => p.theme.fontStyles.Body4};
        -webkit-line-clamp: 3;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;

        margin-bottom: 10px;
    }
`;
